(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loomera-features"] && !Shopify.designMode) return;
  try {
    
  /**
   * "Built for use" — front/back image crossfade.
   *
   *   Desktop (>=750px): pure CSS :hover crossfade. JS does nothing.
   *   Mobile  (<=749px): scroll-driven crossfade via --features-progress.
   *
   * The mobile path is gated by matchMedia, so resizing across the
   * breakpoint hot-swaps modes without reload. Both modes share the
   * same back-image preloader so the crossfade never reveals a
   * half-loaded image.
   *
   * Tune the mobile scroll timing via SCROLL_BAND_START / SCROLL_BAND_END
   * below. Tune the desktop hover speed via the --features-hover-*
   * custom properties in theme.css.
   */
  (() => {
    const wraps = document.querySelectorAll('[data-features-image-wrap].loom-features__image-wrap--dual');
    if (!wraps.length) return;

    // Active scroll band, expressed as a fraction of the section's
    // travel through the viewport (0 = section top edge entering bottom
    // of viewport, 1 = section bottom edge leaving top). Raise START to
    // delay the swap; narrow the gap (END − START) for a faster fade.
    const SCROLL_BAND_START = 0.33;
    const SCROLL_BAND_END   = 0.42;

    const reduceMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileMQ       = window.matchMedia('(max-width: 749px)');

    // ---------- Preload the back image (both modes) ----------
    if ('IntersectionObserver' in window) {
      const preloadIO = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const img = entry.target.querySelector('.loom-features__image-back img');
          if (img) {
            img.loading = 'eager';
            if ('fetchPriority' in img) img.fetchPriority = 'high';
          }
          preloadIO.unobserve(entry.target);
        }
      }, { rootMargin: '200% 0px' });
      wraps.forEach((w) => preloadIO.observe(w));
    }

    // ---------- Mobile-only scroll-driven crossfade ----------
    const visible = new Set();
    let viewIO = null;
    let scrollBound = false;
    let frame = 0;

    const update = () => {
      frame = 0;
      if (!visible.size) return;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const bandSize = SCROLL_BAND_END - SCROLL_BAND_START;
      visible.forEach((wrap) => {
        const section = wrap.closest('.loom-features') || wrap;
        const rect = section.getBoundingClientRect();
        const total = vh + rect.height;
        if (total <= 0) return;
        const raw = (vh - rect.top) / total;
        let t = (raw - SCROLL_BAND_START) / bandSize;
        if (t < 0) t = 0; else if (t > 1) t = 1;
        // Smoothstep: 3t² − 2t³
        const eased = t * t * (3 - 2 * t);
        wrap.style.setProperty('--features-progress', eased.toFixed(3));
      });
    };

    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };

    const enableMobileScroll = () => {
      if (viewIO || !('IntersectionObserver' in window)) return;
      viewIO = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            visible.add(entry.target);
          } else {
            entry.target.classList.remove('is-in-view');
            visible.delete(entry.target);
            entry.target.style.setProperty('--features-progress', '0');
          }
        }
        schedule();
      }, { rootMargin: '15% 0px' });
      wraps.forEach((w) => viewIO.observe(w));

      if (!scrollBound) {
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule, { passive: true });
        scrollBound = true;
      }
      schedule();
    };

    const disableMobileScroll = () => {
      if (viewIO) {
        viewIO.disconnect();
        viewIO = null;
      }
      visible.clear();
      // Reset progress so desktop hover starts from a clean slate.
      wraps.forEach((w) => {
        w.classList.remove('is-in-view');
        w.style.setProperty('--features-progress', '0');
      });
    };

    const applyMode = () => {
      if (mobileMQ.matches && !reduceMotionMQ.matches) {
        enableMobileScroll();
      } else {
        disableMobileScroll();
      }
    };

    const bindMQ = (mq, handler) => {
      if (mq.addEventListener) mq.addEventListener('change', handler);
      else if (mq.addListener) mq.addListener(handler);
    };
    bindMQ(mobileMQ, applyMode);
    bindMQ(reduceMotionMQ, applyMode);

    applyMode();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loomera-password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.getElementById('LoomPwModal');
    if (!modal) return;

    var openers = document.querySelectorAll('[data-loom-pw-open]');
    var closers = modal.querySelectorAll('[data-loom-pw-close]');

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var input = modal.querySelector('input[type="password"]');
      if (input) {
        setTimeout(function () { input.focus(); }, 120);
      }
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    // If the password form had an error on load, auto-open the modal
    if (modal.querySelector('.loom-pw__form-error')) {
      open();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
